var map = {
	"./Avatar.doc.js": 148,
	"./AvatarPair.doc.js": 842,
	"./Badge.doc.js": 843,
	"./Box.doc.js": 844,
	"./Button.doc.js": 845,
	"./Callout.doc.js": 846,
	"./Card.doc.js": 847,
	"./Checkbox.doc.js": 848,
	"./Collage.doc.js": 849,
	"./Column.doc.js": 850,
	"./Container.doc.js": 851,
	"./DatePicker.doc.js": 852,
	"./Divider.doc.js": 853,
	"./Flyout.doc.js": 854,
	"./GroupAvatar.doc.js": 855,
	"./Heading.doc.js": 856,
	"./Icon.doc.js": 857,
	"./IconButton.doc.js": 858,
	"./Image.doc.js": 859,
	"./Installation.doc.js": 860,
	"./Label.doc.js": 861,
	"./Layer.doc.js": 862,
	"./Letterbox.doc.js": 863,
	"./Link.doc.js": 864,
	"./Mask.doc.js": 865,
	"./Masonry.doc.js": 866,
	"./Modal.doc.js": 867,
	"./Pog.doc.js": 868,
	"./Provider.doc.js": 869,
	"./Pulsar.doc.js": 870,
	"./RadioButton.doc.js": 871,
	"./Row.doc.js": 872,
	"./SearchField.doc.js": 873,
	"./SegmentedControl.doc.js": 874,
	"./SelectList.doc.js": 875,
	"./Spinner.doc.js": 876,
	"./Stack.doc.js": 877,
	"./Sticky.doc.js": 878,
	"./Switch.doc.js": 879,
	"./Table.doc.js": 880,
	"./Tabs.doc.js": 881,
	"./TapArea.doc.js": 882,
	"./Text.doc.js": 883,
	"./TextArea.doc.js": 884,
	"./TextField.doc.js": 885,
	"./Toast.doc.js": 886,
	"./Tooltip.doc.js": 887,
	"./Typeahead.doc.js": 888,
	"./Video.doc.js": 889,
	"./ZIndexClasses.doc.js": 890,
	"./useReducedMotion.doc.js": 891
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 147;